/**
 * Manages info panel on the Product Filter page, handling its display,
 * toggling, and content organization based on user interactions.
 */
import { eventKeyCodes } from './helpers/eventKeyCodes';

export class infoPanel {
  static isOnPage() {
    return $('.js-info-panel').length > 0;
  }

  constructor() {
    this.init();
  }

  /**
   * Toggles info panel visibility and filters
   * content based on the clicked info icon or close button.
   * @param {Event} event - Passes the element that was clicked on.
   */
  togglePanel (event) {
    let mode = 'close';
    const $targetClick = $(event?.currentTarget);
    const $infoPanelContentGroup = $('.js-info-panel-content-group');     

    if (event) {
      mode = $targetClick.hasClass('info-panel-close-button') ? 'close' : 'open';
    }

    $('.js-info-panel-wrapper').toggleClass('info-panel-wrapper--opened', mode !== 'close');
    $('.js-info-panel').toggleClass('info-panel--opened', mode !== 'close');
    $infoPanelContentGroup.removeClass('info-panel-content-group--hide');

    if (mode === 'open') {
      const $selectedFilterGroup = $targetClick.data('filter-group');

      $infoPanelContentGroup.each((index, element) => {
        const $filterGroup = $(element);

        if ($filterGroup.data('filter-group') !== $selectedFilterGroup) {
          $filterGroup.addClass('info-panel-content-group--hide');
        }
      });
      this.toogleInfoPanelTabindex(true);

      // focus on first focusable element in info panel that is not close button
      const modalContent = $('.info-panel-content .info-panel-content-group:not(.info-panel-content-group--hide)');
      const closeButton = $('.info-panel-close-button.js-info-panel-toggle');
      const focusableElements = modalContent.find('[tabindex="0"]');
      const focusable = Array.from(focusableElements);
  
      const firstFocusable = focusable[0];
      if (firstFocusable) {
        firstFocusable.focus();
      }
      // add event that listen tab key, last focusable element should be close button
      modalContent.on('keydown', (e) => {
        if (e.key === 'Tab') {
          const last = focusable[focusable.length - 1];

          if (!e.shiftKey) {
            // if using only (Tab)
            if (document.activeElement === last) {
              e.preventDefault();
              closeButton.focus(); // return to close button 
            }
          } 
        }
      });
    } else {
      this.toogleInfoPanelTabindex(false);
      const selectedSvg = $('.complementary-info.js-info-panel-toggle[data-filter-group=' + sessionStorage.getItem('selectedFilterGroupName') + ']');

      if(selectedSvg){
        selectedSvg.first().focus();
      }
      sessionStorage.removeItem('selectedFilterGroupName');
    }
  };

  toogleInfoPanelTabindex (isOpen) {
    if (isOpen) {
      $('.info-panel-close-button.js-info-panel-toggle').attr('tabindex',0);
      $('.info-panel-content-group .info-panel-mainTitle').attr('tabindex',0);
      $('.info-panel-content-group .info-panel-title').attr('tabindex',0);
      $('.info-panel-content-group .info-panel-description').attr('tabindex',0);
    } else {
      $('.info-panel-close-button.js-info-panel-toggle').removeAttr('tabindex');
      $('.info-panel-content-group .info-panel-mainTitle').removeAttr('tabindex');
      $('.info-panel-content-group .info-panel-title').removeAttr('tabindex');
      $('.info-panel-content-group .info-panel-description').removeAttr('tabindex');
    }
  }

  /**
   * Initializes the info panel by setting up a click event listeners.
   */
  init() {
    // Open/close panel when the trigger element is clicked
    $('.js-info-panel-toggle').on('click keydown', (event) => {
      if (event.type === 'click' || event.keyCode === eventKeyCodes.enter || event.keyCode === eventKeyCodes.space) {
        event.preventDefault();
        sessionStorage.setItem('selectedFilterGroupName', $(event?.currentTarget).data('filter-group'));
        this.togglePanel(event);  
       }
    }); 

    // Close the panel when a click event occurs outside the panel content
    $(document).on('click keydown', event => {      
      ($(event.target).is('.js-info-panel-wrapper') || event.keyCode === eventKeyCodes.escape) && this.togglePanel();     
    });

  }
}